import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const progressBarVariants = tv({
  base: 'flex justify-center items-center',
  variants: {
    variant: {
      default: 'bg-gray-500 text-base-white hover:bg-gray-500/90',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ProgressBarProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof progressBarVariants> & {
    percentage?: number;
    completedColor?: string;
    className?: string;
    barClassName?: string;
    loading?: boolean;
  };

export const ProgressBar = React.forwardRef<HTMLDivElement, ProgressBarProps>(
  (
    { className, variant, percentage, barClassName, loading = false, ...props },
    ref,
  ) => {
    return (
      <div
        className={cn(
          'h-1 w-full overflow-hidden rounded-md bg-gray-200',
          {
            'animate-pulse bg-gray-300': loading,
          },
          className,
          variant,
        )}
        ref={ref}
        {...props}
      >
        {!loading && (
          <div
            className={cn(
              'h-full origin-left transform rounded-md bg-green-500 transition-all duration-500',
              barClassName,
            )}
            style={{ width: `${percentage}%` }}
          />
        )}
      </div>
    );
  },
);

ProgressBar.displayName = 'ProgressBar';
